import Typography, { TypographyProps } from '@mui/material/Typography'
import { Trans } from 'react-i18next'

type MailToProps = {
    email: string
    subject?: string
    typographyProps?: TypographyProps
    body?: string
    ctaI18nKey?: string
}

const MailTo = ({
    email,
    subject,
    typographyProps,
    body,
    ctaI18nKey
}: MailToProps) => {
    const baseUrl = `mailto:${email}`
    const bodyString = body ? `&body=${encodeURIComponent(body)}` : ''
    const link = subject
        ? `mailto:${email}?subject=${encodeURIComponent(subject)}${bodyString}`
        : baseUrl

    return (
        <Typography component="span" {...typographyProps}>
            <Trans i18nKey={ctaI18nKey || 'common:contact.mailTo'}>
                Contact us at <a href={link}>{email}</a>
            </Trans>
        </Typography>
    )
}

export default MailTo
